import styled from 'styled-components';

export const SliderWrapper = styled.div`
  position: relative;
  margin: 2rem auto 4rem auto;
  max-width: 60rem;
  max-height: 60rem;
`;

export const SliderContainer = styled.div`
  margin-top: 2rem;

  .tables {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
